import React, { useMemo } from "react";
import { Button, Stack } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { ErrorMessage } from "formik";
import { FieldError } from "./FieldError";

interface Props {
  variant?: "contained" | "outlined";
  color?: "primary" | "inherit";
  type?: "button" | "submit" | "reset";
  text: string;
  onClick?: () => void;
  sx?: any;
  className?: string;
  isLoadingBtn?: boolean;
  loading?: boolean;
}

export function FormButton(props: Props) {
  const {
    variant,
    color,
    type = "submit",
    text,
    isLoadingBtn,
    ...rest
  } = props;

  const Component = useMemo(
    () => (isLoadingBtn ? LoadingButton : Button),
    [isLoadingBtn]
  );

  return (
    <Stack justifyContent="center" spacing={2}>
      <Component
        variant={variant || "contained"}
        color={color || "primary"}
        disableElevation
        size="large"
        type={type || (rest.onClick ? "button" : "submit")}
        style={{ textTransform: 'none', fontFamily: 'CircularStdBlack' }}
        {...rest}
      >
        {text}
      </Component>
      {!rest?.onClick && (
        <ErrorMessage name="form">
          {(msg) => <FieldError>{msg}</FieldError>}
        </ErrorMessage>
      )}
    </Stack>
  );
}
